import each from '@ali/xutil/each';
import isFunction from 'lodash/isFunction';
import InvokerQianniu from '../invokers/qianniu-pc';

const win = window;
const doc = document;
const EXCLUDES = {
    application: true,
    top: true,
};

/**
 * create a X plugin by name which from module of `window.workbench`.
 * @param  {String} name  plugin name
 * @return {Function}     new X plugin
 */
function createPlugin(name) {
  return (X) => {
    let plugin = {
      invoke(options) {
        // To support api alias, we need to get api info from api map.
        let api = X.getApiByAlias(options.api);
        options.api = api || {
          type: X.API_TYPE[`QN_${name.toUpperCase()}`],
          uri: options.api,
        };
        return  X.call(options);
      }
    };
    return plugin;
  };
}

export default (X) => {

  function autoPlug() {
    if (!win.workbench) return;

    each(workbench, (module, moduleName) => {
      if (!module || !isFunction(module.invoke)) return;
      if (EXCLUDES[moduleName]) return;

      let type = X.API_TYPE[`QN_${moduleName.toUpperCase()}`] = `QN.${moduleName}`;
      X.addInvoker(InvokerQianniu(type));
      X.plug(moduleName, createPlugin(moduleName));
    });
  }

  // support async import
  if (doc.readyState === 'complete') {
    autoPlug();
  } else {
    if (!doc.addEventListener) return;
    doc.addEventListener('DOMContentLoaded', autoPlug);
  }
}



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-auto-plug.js